<template>
    <div class="box">
        <div class="level is-mobile">
            <div class="level-left">
                <div class="level-item">
                    <p class="subtitle has-text-grey-light">
                        {{ $t($route.name) }}
                    </p>
                </div>
            </div>
            <div class="level-right">
                <div class="level-item">
                    <slot name="buttons" />
                </div>
            </div>
        </div>
        <slot name="content" />
    </div>
</template>

<script>
export default {};
</script>

<style scooped>
.box {
    width: auto;
}
</style>
